// import { getUser } from '../../src/components/config/userdetails.js'


// let {  name,value} = getUser()


let serviceUrl = ''
    // serviceUrl = "http://192.168.0.30:8080/"
    serviceUrl = "https://support.oxygen-global.com/cardholderadmin/"
    // serviceUrl = "https://www.my-rewardscard.com/adminportal/"

// else
// {
//      serviceUrl = localStorage.getItem('serviceUrl')
// }
// const serviceUrl = "https://www.gmcabscard.com.au/services/api/"
// const serviceUrl = (baseUrl === null ? "http://192.168.2.24:8080/" : baseUrl)

const services = {
    login:serviceUrl + "public/token",
    // signup: url + "public/signup/create",
    // profileimg: url + "rest/profile/updatePicture",
    // capcha: url + "public/captcha",
    get_public_key:   serviceUrl +  +"public/card/getkey/myrewards",
    get_customerList: serviceUrl + "customer/public/customer",
    // verify_card: url + "public/card/verify",
    // store_card: url + "public/card/storeCard",
    // activate_card: url + "public/card/activate",
    // secret_ques: url + "public/signup/getAllSecretQuestions",
    // update_user_info: url + "public/card/updateUserSecurityInfo",
    get_cards: serviceUrl + "rest/card/getCards",
    // find_member: url + "rest/member/findMembers",
    // add_friend: url + "rest/member/addFriend",
    get_profile: serviceUrl + "rest/profile/read",
    // update_basic: url + "rest/profile/updateBasicInfo",
    // update_contact: url + "rest/profile/updateContactInfo",
    // update_mailing: url + "rest/profile/updateMailingInfo",
    // get_friend: url + "rest/member/getFriends",
    // dlt_friend: url + "rest/member/deleteFriend",
    // edit_friend: url + "rest/member/editFriend",
    // change_password: url + "rest/profile/changePassword",
    // share_fund: url + "rest/card/shareFunds",
    // change_pin: url + "rest/card/changePIN",
    get_userid: serviceUrl + "public/card",
    // get_password: url + "public/validateUserId",
    // forgot_password: url + "public/forgotPassword",
    // block_card: url + "rest/card/setCardStatus",
    // country: url + "public/signup/country",
    // change_seq_que: url + "rest/profile/updateSecretQA",
    // send_userid: url + "public/getUserId",
    // get_transactionid: url + "rest/card/transactionHistory",
    // get_alerts: url + "rest/card/readAlerts",
    // deb_txnpost_alert: url + "rest/card/debitTxnPostAlert",
    // cdt_txnpost_alert: url + "rest/card/creditTxnPostAlert",
    // card_bal_alert: url + "rest/card/cardBalanceAlert",
    // insuf_bal_alert: url + "rest/card/NonSufficientFundsAlert",
    // other_alert: url + "rest/card/updateCardAlert",
    get_cardactivity: serviceUrl + "rest/card/getCardActivity",
    // contact_us: url + "public/contactus",
    // valid_user_id: url + "public/signup/verifyUserName",
    // update_forceSecret: url + "rest/profile/forceSecretQAUpdate",
    card_detail_service: serviceUrl + "rest/card/detailsByCardReferenceId",
    update_card_status: serviceUrl + "rest/card/updateCardStatusByRefId",
    update_emailid: serviceUrl + "rest/profile/updateEmailAddress",
    userid_info: serviceUrl + "rest/card/detailsByUserId",
    mobno_info: serviceUrl + "rest/card/detailsByMobileNumber",
    card_detail_by_cardno_service: serviceUrl + "rest/card/detailsByCardNumber",
    // userid_info: url + "rest/card/detailsByUserId",
    // mobno_info: url + "rest/card/detailsByMobileNumber",
    // send_api_link: url + "public/sendMobileAppLink",
    // resetsq_card_verify: url + "public/verifyCardNumber",
    // resetsq_expiry_verify: url + "public/verifyExpiryDate",
    // resetsq_mobNum_verify: url + "public/verifyMobileNumber",
    // resetsq_dob_verify: url + "public/verifyDateOfBirth",
    // resetsq_qa: url + "public/resetSecretQA",
    update_cardholder_info: serviceUrl + "rest/profile/updateProfile"

}

export default services;



// WEBPACK FOOTER //
// ./src/services/allservices.jsx